import React from 'react';
import { TickerBar } from './components/TickerBar';
import { HeroSection } from './components/HeroSection';
import { IdentificationSection } from './components/IdentificationSection';
import { SolutionSection } from './components/SolutionSection';
import { FeaturesSection } from './components/FeaturesSection';
import { PricingSection } from './components/PricingSection';
import { BonusSection } from './components/BonusSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { ValueStack } from './components/ValueStack';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FAQSection } from './components/FAQSection';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { StickyBar } from './components/StickyBar';
export function App() {
  return <div className="min-h-screen w-full bg-bg text-text font-sans" data-id="element-0">
      <TickerBar data-id="element-1" />
      <HeroSection data-id="element-2" />
      <IdentificationSection data-id="element-3" />
      <SolutionSection data-id="element-4" />
      <FeaturesSection data-id="element-5" />
      <PricingSection data-id="element-6" />
      <BonusSection data-id="element-7" />
      <TestimonialsSection data-id="element-8" />
      <ValueStack data-id="element-9" />
      <GuaranteeSection data-id="element-10" />
      <FAQSection data-id="element-11" />
      <FinalCTA data-id="element-12" />
      <Footer data-id="element-13" />
      <StickyBar data-id="element-14" />
    </div>;
}